import React, { Component } from "react";
import Dialog from "../../../dialogs/dialog";
import { GlobalContext } from "../../../../utils/globalprovider.js";
import { apigetProjectsListByUser } from "../../../../utils/apis";
import { getCurrentUserDatas } from "../../../../utils/software.js";

import LoginEditUser from "../../appcomponents/user/loginedituser.js";


import imguser4 from "./assets/user4.png"
import imguser2 from "./assets/user2.png"
import imguser1 from "./assets/user1.png"

import Tooltip from "../../../../components/bases/tooltips/tooltip";
import SimplePopup from "../../../../components/bases/popup/simplePopup.js";

import "../../tables/tables.css"

import { apiGetShortUserList, apiDeleteUser } from "../../../../utils/apis";

class UsersList extends Dialog
{
  constructor(props) 
  {
    super(props);

    var title = {en:"Project Owner",  fr:"Propriétaire du projet"}
    if (this.props.edit)
      title = {fr:"Utilisateurs",  en:"Users"}

    this.state.title = title;
    this.state.pjuser = this.props.pjuser;
    this.state.displayform = false;
    this.state.formaction = ""; // add / edit / remove 
    this.state.formulaire = {}
    this.state.displayPopup = false
    this.state.popupText = {}
    this.state.popupButtons = []
    this.state.displayedituser = false;
    this.state.displaycreateuser = false;

    
    this.exitAllPopup = this.exitAllPopup.bind(this)
    


    this.onCLickOnUser = this.onCLickOnUser.bind(this);

    var buttons = [];

    if ((this.props.select) && (!this.props.edit))
    {
        
        buttons.push({type:"text", disabled:false,text:{fr:"Sélectionner",en:"Select"},key:"select"})
    }
    else
    {
        buttons.push({type:"text", disabled:!this.isSuperuser(),text:{fr:"Nouvel utilisateur",en:"Create user"},key:"create"})
        buttons.push({type:"text", disabled:true,text:{fr:"Modifier",en:"Edit"},key:"edit"})
        buttons.push({type:"text", disabled:true,text:{fr:"Supprimer",en:"Delete"},key:"delete"})
    }
  
    buttons.push({type:"back", disabled:false});

    this.state.buttons = buttons;
    this.state.liste = [];
    this.state.columms = [];


    this.handleButton =  this.handleButton.bind(this);
    this.handleSelectButton = this.handleSelectButton.bind(this)
    this.onGetTableList = this.onGetTableList.bind(this)

    this.onQuit = this.onQuit.bind(this)

    this.getProjectListForDelete = this.getProjectListForDelete.bind(this)
    this.onDeleteUser = this.onDeleteUser.bind(this)
    this.onDeleteUserDone = this.onDeleteUserDone.bind(this)
    this.onFinishEditUser = this.onFinishEditUser.bind(this)
    this.onFinishCreateUser= this.onFinishCreateUser.bind(this)
   
  }

  isSuperuser()
  {
    const droits = getCurrentUserDatas().droits;
    return ((droits & 4) !== 0)
  }

  onFinishCreateUser(userid)
  {
      this.setDisabledButtonByKey("edit", true);
      this.setDisabledButtonByKey("delete", true);
      apiGetShortUserList (this.onGetTableList);


  }

  onDeleteUser()
  {
    apiDeleteUser(this.state.pjuser, this.onDeleteUserDone);

  }
  onDeleteUserDone()
  {
      this.setDisabledButtonByKey("edit", true);
      this.setDisabledButtonByKey("delete", true);
      apiGetShortUserList (this.onGetTableList);
  }

  exitAllPopup()
  {

    this.setState({displayPopup:false, displayedituser: false, displaycreateuser:false})
  }

  handleButton(buttonkey)
  {
    
    switch (buttonkey)
    {
        case "back":
          this.onQuit();
          break;
        case "select":
          this.props.onvalidform (
            {
              ret:true,
              id: this.state.pjuser,
            }
          )
          break;

        case "edit":
          this.setState({displayedituser: true})
          break;

        case "create":
          this.setState({displaycreateuser: true})
          break;
        case "delete":
          apigetProjectsListByUser(this.state.pjuser, this.getProjectListForDelete)

          break;
  
    }
   
  }

  getProjectListForDelete(datas)
  {
    
    if (datas.length === 0)
    {
      this.setState({
        displayPopup: true,
        popupText: {fr:"Confimez vous la suppression de cet utilisateur ?",en:"Do you confirm the deletion of this user?"},
        popupButtons :
          [
            {text:{"fr":"Oui","en":"Yes"},onclick:this.onDeleteUser},
            {text:{"fr":"Non","en":"No"},onclick:this.exitAllPopup},
          ]
      })
    }
    else
    {
      this.setState({
        displayPopup: true,
        popupText: {fr:"Il existe des projets pour cet utilisateur. Supprimez ou réaffectez d'abord ces projets.",en:"There are projects for this user. Delete or reassign these projects first."},
        popupButtons : []
    })
    }
}

  onQuit()
  {
    
      this.props.onvalidform({ret:false})
  }

  onValid()
  {
    
  }

  onGetTableList(datas)
  {
    if (this.props.edit)
    {

      var pjuser =0;
      this.state.liste.forEach(user=>{
        if (user.id === this.state.pjuser) pjuser = this.state.pjuser;
      }
      )

      this.setState({liste:datas, displayPopup:false, pjuser:pjuser});
    }
    else
      this.setState({liste:datas, displayPopup:false});
    
  }
  componentDidMount()
  {
    super.componentDidMount();

      apiGetShortUserList (this.onGetTableList);


    var txtfirstname = this.context.language=="fr"?"Prénom":"First Name";
    var txtlastname = this.context.language=="fr"?"Nom":"Last Name";

    var txtpicture = this.context.language=="fr"?"Image":"Picture";

    var columms = [
      {text:"Id", width:5, zone: "id", type:"text", align:"center"},
      {text:txtlastname, width:24, zone: "lastname", type:"text", align:"left"},
      {text:txtfirstname, width:24, zone: "firstname", type:"text", align:"left"},
      {text:"Email", width:29, zone: "email", type:"text", align:"left"},
      {text:txtpicture, width:9, zone: "image", type:"image", align:"center"},
      {text:"Type", width:9, zone: "droits", type:"droits", align:"center"},
      
  ]
     this.setState({columms: columms})


  }

  onCLickOnUser(index)
  {
    
    this.setState({pjuser: this.state.liste[index].id})

    // on valide les boutons

      this.setDisabledButtonByKey("edit", (1 === this.state.liste[index].id) || !this.isSuperuser());
      this.setDisabledButtonByKey("delete", (1 === this.state.liste[index].id) || !this.isSuperuser());
      this.setState({pjuser: this.state.liste[index].id})

  }

  handleSelectButton(datas)
  {
      this.props.onvalidform({ret:true, id:datas.id})
  }

  onFinishEditUser(datas)
  {
      this.exitAllPopup();
      apiGetShortUserList (this.onGetTableList);
  }

  onFinishCreateUser(datas)
  {
      console.log("finish create", datas)
      if (datas !== null)
      {
        // ici un utilisateur a été créé
      }
      this.exitAllPopup();
      apiGetShortUserList (this.onGetTableList);
  }

  
  
  
  render()
  {


    var maxwidth =  (window.innerWidth * 60)/100;
    if (maxwidth > 800) maxwidth = 800;

    var maxheight =  (window.innerHeight * 75)/100;
    if (maxheight > 400) maxheight = 400;

    var localrender =[];
    
    var listelement = [];

    for (let i=0; i < this.state.liste.length; i++)
    {
      var style = {backgroundColor: "transparent"};
      if (i & 1)
        style = {backgroundColor: "#202020"};

      if (this.state.pjuser == this.state.liste[i].id)
        style.backgroundColor = "#7E97BC"; // #9EB7CC";

      listelement.push(
          <tr
            key={this.state.liste[i].id} 
            style={style} onClick={e=>{this.onCLickOnUser(i);}}
          >
          <ListTableElement 
          onselect = {this.handleSelectButton}
          index={i} columms = {this.state.columms} values = {this.state.liste[i]} />  
          </tr>
        )
    }


    var edituser = (<></>)
    if (this.state.displayedituser)
    edituser =(
      <LoginEditUser 
        onCancelKeyboardEvent = {this.exitAllPopup}
        userId = {this.state.pjuser}
        onfinish={this.onFinishEditUser}/>
    )  
    else
    {
      if (this.state.displaycreateuser)
      {
        edituser =(<LoginEditUser 
          onCancelKeyboardEvent = {this.exitAllPopup}
          userId = {0}
          create = {true}
          onCreateUser = {this.onFinishCreateUser}
          onfinish={this.onFinishCreateUser}/>)

      }
    }
    

    
    localrender.push(
      <>

          <SimplePopup display={this.state.displayPopup} 
                title="" text={this.state.popupText} 
                onCancel={this.exitAllPopup}
                buttons = {this.state.popupButtons}
                
            />

            {edituser}

            <div className="table-limit" style={{width:maxwidth, height:maxheight}}>

            <div className="table-container-header">
            <table className="table-tableList" cellSpacing={5} cellPadding={0}>
            <ListTableHeader columms = {this.state.columms} />          
            </table>
            </div>
            <div className="table-container">
            <table className="table-tableList" cellSpacing={5} cellPadding={0}>
                  {listelement}
            </table>      
            </div>
            </div>          
                

      </>          
      );



    return super.render(localrender);
  }


}
UsersList.defaultProps = 
{
    selectButton: false,
    selectedId: 0,
    zorder:2,
}

//  ****************************************************************************************
//  ListTablesHeader
//  ****************************************************************************************
class ListTableHeader extends React.Component{
    constructor(props)
    {
        super(props);
    }

    createAllHeaderColumms()
    {
        var retour = []
        var styleh = "table-headerList"
        for (var i=0; i<this.props.columms.length; i++)
        {
            var width = this.props.columms[i].width + "%"
            var key="userheader" + i;
          retour.push(
              
              <td width={width} className={styleh} key={key}>
              
                  {this.props.columms[i].text}
              </td>)
        }
        return ( retour)
    }


  render()
  {
      return (
          <>
                  {this.createAllHeaderColumms()}
          </>
      )
  }

}


//  ****************************************************************************************
//  ListTableElement
//  ****************************************************************************************
class ListTableElement extends React.Component
{
  static contextType = GlobalContext;

  constructor(props)
  {
      super(props);
  }



  createAllElementColumms()
  {


      var retour = []
      var styleh = "table-elementList"
      for (var i=0; i<this.props.columms.length; i++)
      {
          var width = this.props.columms[i].width + "%"
          var key="userelement" + i;


          var style = {height:"32px", textAlign: this.props.columms[i].align, paddingLeft:"3px", borderRadius:"4px"};
        switch (this.props.columms[i].type)
        {
          case "text":
            retour.push(
                
                <td width={width} className={styleh} key={key} style={style}>
                
                    {this.props.values[this.props.columms[i].zone]}
                </td>)
            break;
            case "image":
              if (this.props.values[this.props.columms[i].zone] =="")
                retour.push(<td width={width} className={styleh} key={key} style={style}>&nbsp;</td>);
              else
              retour.push(<td width={width} className={styleh} key={key} style={style}>
                  <img height="32" src={this.props.values[this.props.columms[i].zone]}/>
                    </td>);

                
              break;

          case "droits":
            var img = imguser1;
            var text = this.context.language=="fr"?"Utilisateur Base.":"Base User.";
            
            switch (this.props.values.droits)
            {
                case 2:
                    img = imguser2;
                    text = this.context.language=="fr"?"Utilisateur Base avec création de projet.":"Base User who's can create project. ";
                    break;
                case 4:
                    img = imguser4;
                    text = this.context.language=="fr"?"Administrateur.":"Admin.";
                    break;
            }

            retour.push(<td width={width} className={styleh} key={key} style={style}>
                <Tooltip text = {text}>
                <img height="22" src={img}/>
                </Tooltip>
                  </td>);
                break;

            break;
        }
      }
      return ( retour)
  }


render()
{
    return (
        <>
                {this.createAllElementColumms()}
        </>
    )
}

}

UsersList.defaultProps = {
  project:0,
  pjuser:0,
  select:false,
  edit: false,
}
export default UsersList;